module.exports = __webpack_public_path__ + "img/table-tab.7958d7c1.svg";